import Message from './Message';

export default Message;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/message/index.js
// module id = 408
// module chunks = 0